module.exports = __webpack_public_path__ + "static/fonts/Oswald-Extra-LightItalic.5cf0a76.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Extra-LightItalic.ttf
// module id = BGbz
// module chunks = 1